// src/data/courseData.js
export const course = {
  title: "Get Started With Advanced Astrology(Vedic)",
  price: 17999,
  features: [
    "Expert Astrologers",
    "Personalized Solutions",
    "24/7 Support"
  ],
  videoUrl: "https://www.youtube.com/embed/W4tp7E61ea8"
}

export const comments = [
  { id: 1, name: "Prateek", time: "23 hours ago", text: "Good session", likes: 0, dislikes: 0 },
  { id: 2, name: "Prateek", time: "23 hours ago", text: "Good session", likes: 0, dislikes: 0 },
  { id: 3, name: "Prateek", time: "23 hours ago", text: "Good session", likes: 0, dislikes: 0 }
]

export const videoList = [
  { id: 1, title: "2. Calculation of Shadbal Bhavbal and its importance", videoUrl: "https://www.youtube.com/embed/W4tp7E61ea8" },
  { id: 2, title: "2. Calculation of Shadbal Bhavbal and its importance", videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ" },
  { id: 3, title: "2. Calculation of Shadbal Bhavbal and its importance", videoUrl: "https://www.youtube.com/embed/W4tp7E61ea8" },
  // ... 8 more
]